import React, { Component } from "react";
import { Menu } from "@mui/material";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Autocomplete } from "@mui/material";
import { ValidatorForm } from "react-material-ui-form-validator";
import { InputAdornment } from "@mui/material";
// import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import CreateButton from "../buttons/CreateButton";
import CancelIconButton from "../buttons/CancelIconButton";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import { withRouter } from "../../../withRouter";
import { Buffer } from "buffer";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import PtsButton from "../buttons/PtsButton";
import Utils from "../../../provider/Utils";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import PtsAlert from "../ptsAlert/PtsAlert";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import {
  AddContactsToGroup_Url,
  ContactList_Url,
  ExportSmsContacts_Url,
  GroupList_Url,
  ImportContacts_Url,
  GetGroupList_Url,
  DeleteContact_Url,
  neonCrmSyncContacts_Url,
  blackbaudCrmSyncContacts_Url,
  DPTextCrmSyncContacts_Url,
  DeleteContactFromGroup_Url,
  UpdateContact_Url,
  FindByNumber_Url,
} from "../../../provider/ServiceUrl";
import DeleteButton from "../buttons/DeleteButton";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import RemoveContactButton from "../buttons/RemoveContactButton";
import Pagination from "../pagination/Pagination";
import _ from "lodash";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import EditButton from "../buttons/EditButton";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
class AllActiveContactList extends Component {
  fileUploadRef = React.createRef();
  header = store.getState().header.header;
  allActiveState = store.getState().applicationState.allActiveState;
  optinPaginationState = store.getState().paginations.optinContactsState;
  paindingPaginationState = store.getState().paginations.paindingContactsState;
  optoutPaginationState = store.getState().paginations.optoutContactsState;
  invalidPaginationState = store.getState().paginations.invalidContactsState;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  allActiveStateDetails = {};
  paginationStateDetails = {};
  breadCrumb = [{ pageid: "", uiname: "Opt-ins" }];
  title = "View and manage your contact lists including opt-ins";
  constructor(props) {
    super(props);
    if (this.allActiveState) {
      this.allActiveStateDetails = Object.getOwnPropertyNames(
        this.allActiveState
      );
    }

    if (this.optinPaginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.optinPaginationState
      );
    }

    if (this.allActiveStateDetails.length > 0) {
      this.state = {
        initialPage: this.allActiveState.initialPage,
        pageSize: this.allActiveState.pageSize,
        contactId: this.allActiveState.contactId,
        selectedTab: this.allActiveState.selectedTab,
        mobileNo: "",
        mobile: "",
        firstName: "",
        lastName: "",
        email: "",
        smsContactList: [],
        activeContactListArr: [],
        inActiveContactListArr: [],
        optOutContactListArr: [],
        invalidContactListArr: [],
        smsGroupList: [],
        selectedSMSContactList: new Set(),
        selectedFile: { name: "" },
        checkCSVFile: false,
        isPaging: false,
        openViewGroup: false,
        isActiveContactListPaging: false,
        isInActiveContactListPaging: false,
        isOptOutContactListPaging: false,
        isInvalidContactListPaging: false,
        getCreatePermission: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        getReportPermission: false,
        open: false,
        openImport: false,
        isCtrlPressed: false,
        isShiftPressed: false,
        isSelected: false,
        allOptinSelected: false,
        allInactiveSelected: false,
        allOptoutSelected: false,
        allInvalidSelected: false,
        isDownloadReport: false,
        isContactConfirmBoxOpen: false,
        render: false,
        sortColumn: this.allActiveState?.sortColumn,
        isAscSort: this.allActiveState?.isAscSort,
        sortDirection: "asc",
        searchText: "",
      };
    } else {
      this.state = {
        initialPage: 0,
        pageSize:
          this.paginationStateDetails?.length > 0
            ? this.optinPaginationState?.pageSize
            : 100,
        selectedTab: 0,
        totalRecords: 0,
        mobileNo: "",
        mobile: "",
        firstName: "",
        lastName: "",
        email: "",
        smsContactList: [],
        activeContactListArr: [],
        inActiveContactListArr: [],
        optOutContactListArr: [],
        invalidContactListArr: [],
        smsGroupList: [],
        selectedSMSContactList: new Set(),
        contactId: "",
        selectedFile: { name: "" },
        checkCSVFile: false,
        isPaging: false,
        isNeonIntegration: false,
        isBlackbaudIntegration: false,
        isCventIntegration: false,
        isDpTextIntegration: false,
        isActiveContactListPaging: false,
        isInActiveContactListPaging: false,
        isOptOutContactListPaging: false,
        isInvalidContactListPaging: false,
        getCreatePermission: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        getReportPermission: false,
        open: false,
        openEditContact: false,
        openImport: false,
        isCtrlPressed: false,
        isShiftPressed: false,
        isSelected: false,
        allOptinSelected: false,
        allInactiveSelected: false,
        allOptoutSelected: false,
        allInvalidSelected: false,
        isDownloadReport: false,
        isContactConfirmBoxOpen: false,
        render: false,
        sortColumn: this.paginationStateDetails?.length > 0
          ? this.optinPaginationState?.sortColumn : null,
        isAscSort: this.paginationStateDetails?.length > 0
          ? this.optinPaginationState?.isAscSort : false,
        sortDirection: "asc",
        isDatanotfound: true,
        searchText: "",
      };
    }
    this.getAllContactList(this.state.selectedTab, this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
    this.debouncedSearch = _.debounce(this.getAllContactList, 800);
  }

  getGroupList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(GroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          for (let i = 0; i < smsGroupList.length; i++) {
            smsGroupList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(smsGroupList[i].createdOn) : Utils.getUtcToLocal(
              smsGroupList[i].createdOn
            );
          }
          this.setState({
            open: true,
            smsGroupList: smsGroupList,
          });
        } else {
        }
      }
    );
  }

  getAllContactList(tab, pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
      contactStatus: { id: tab + 1 },
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    FetchServerData.callPostService(ContactList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsContactDetails = output.data;
          let smsContactList = output.data.smsContactList;
          let smsCredits = output.data.smsCredits;
          let page = output.data.page;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getSubDomainPermission =
            output.data.subDomainObjectPrivileges?.ContactReport;
          let getCreatePermission = getPermission[1];
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let getReportPermission =
            getSubDomainPermission === null ? false : true;
          let isPaging = false;
          let activeContactListArr = [];
          let inActiveContactListArr = [];
          let optOutContactListArr = [];
          let invalidContactListArr = [];
          let isActiveContactListPaging = false;
          let isInActiveContactListPaging = false;
          let isOptOutContactListPaging = false;
          let isInvalidContactListPaging = false;
          if (smsCredits !== null) {
            const { showCardexpiryMessage, ...smsCreditsWithoutFlag } = smsCredits;

            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              store.dispatch(
                SelectedDomainAction.setEventCreditUsage(smsCreditsWithoutFlag)
              );
            } else {
              store.dispatch(
                AppUserDataAction.setUsage(smsCreditsWithoutFlag)
              );
            }
          }
          for (let i = 0; i < smsContactList.length; i++) {
            if (Utils.equalsIgnoreCase(smsContactList[i].status, "Optin")) {
              activeContactListArr.push(smsContactList[i]);
            } else if (
              Utils.equalsIgnoreCase(smsContactList[i].status, "InActive")
            ) {
              inActiveContactListArr.push(smsContactList[i]);
            } else if (
              Utils.equalsIgnoreCase(smsContactList[i].status, "OptOut")
            ) {
              optOutContactListArr.push(smsContactList[i]);
            } else if (
              Utils.equalsIgnoreCase(smsContactList[i].status, "InvalidNumber")
            ) {
              invalidContactListArr.push(smsContactList[i]);
            }
          }
          for (let i = 0; i < activeContactListArr.length; i++) {
            activeContactListArr[i].rowNum = i + 1;
          }
          for (let i = 0; i < inActiveContactListArr.length; i++) {
            inActiveContactListArr[i].rowNum = i + 1;
          }
          for (let i = 0; i < optOutContactListArr.length; i++) {
            optOutContactListArr[i].rowNum = i + 1;
          }
          for (let i = 0; i < invalidContactListArr.length; i++) {
            invalidContactListArr[i].rowNum = i + 1;
          }

          if (activeContactListArr.length > this.state.pageSize) {
            isActiveContactListPaging = true;
          }

          if (inActiveContactListArr.length > this.state.pageSize) {
            isInActiveContactListPaging = true;
          }
          if (optOutContactListArr.length > this.state.pageSize) {
            isOptOutContactListPaging = true;
          }
          if (invalidContactListArr.length > this.state.pageSize) {
            isInvalidContactListPaging = true;
          }
          if (smsContactList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < smsContactList?.length; i++) {
            const element = smsContactList[i];
            smsContactList[i].mobile = Utils.viewTollFreeNumberFormate(
              element.mobile
            );
            smsContactList[i].lastMessageSenton = Utils.getUtcToLocalDateTime(
              element.lastMessageSenton
            );
            smsContactList[i].createdOn = Utils.getUtcToLocalDateTime(
              element.createdOn
            );
          }
          this.setState({
            render: true,
            isDatanotfound: page.total === 0 ? true : false,
            open: false,
            openImport: false,
            checkCSVFile: false,
            isPaging: isPaging,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            smsContactList: smsContactList,
            activeContactListArr: activeContactListArr,
            inActiveContactListArr: inActiveContactListArr,
            optOutContactListArr: optOutContactListArr,
            invalidContactListArr: invalidContactListArr,
            isActiveContactListPaging: isActiveContactListPaging,
            isInActiveContactListPaging: isInActiveContactListPaging,
            isOptOutContactListPaging: isOptOutContactListPaging,
            isInvalidContactListPaging: isInvalidContactListPaging,
            isNeonIntegration: smsContactDetails.isNeonIntegration,
            isBlackbaudIntegration: smsContactDetails.isBlackbaudIntegration,
            isCventIntegration: smsContactDetails.isCventIntegration,
            isDpTextIntegration: smsContactDetails.isDpTextIntegration,
            getCreatePermission: getCreatePermission,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
            getReportPermission: getReportPermission,
          });
        } else {
        }
      }
    );
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(
      this.state.selectedTab,
      this.state.pageNo,
      this.state.pageSize
    );
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;

    const contactsState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    if (this.state.selectedTab === 0) {
      store.dispatch(
        PaginationRowAction.setOptinsPaginationState({ optinContactsState: contactsState })
      );
    } else if (this.state.selectedTab === 1) {
      store.dispatch(
        PaginationRowAction.setPaindingPaginationState({ paindingContactsState: contactsState })
      );
    } else if (this.state.selectedTab === 2) {
      store.dispatch(
        PaginationRowAction.setOptoutPaginationState({ optoutContactsState: contactsState })
      );
    } else if (this.state.selectedTab === 3) {
      store.dispatch(
        PaginationRowAction.setInvalidPaginationState({ invalidContactsState: contactsState })
      );
    }

    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    let dataRows = this.state.smsContactList;
    for (let i = 0; i < dataRows.length; i++) {
      dataRows[i].checked = false;
      this.setState({
        allOptinSelected: false,
        allInactiveSelected: false,
        allOptoutSelected: false,
        allInvalidSelected: false,
        isSelected: false,
      });
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    this.getAllContactList(this.state.selectedTab, currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort);
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("keyup", this.handleKeyUp);
  }

  handleKeyDown = (event) => {
    if (event.key === "Control") {
      this.setState({ isCtrlPressed: true });
    } else if (event.key === "Shift") {
      this.setState({ isShiftPressed: true });
    }
  };

  handleKeyUp = (event) => {
    if (event.key === "Control") {
      this.setState({ isCtrlPressed: false });
    } else if (event.key === "Shift") {
      this.setState({ isShiftPressed: false });
    }
  };

  addMessage() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessage", {
        state: {
          action: "create",
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessage", {
        state: {
          action: "create",
        },
      });
    } else {
      this.props.navigate("/message", {
        state: {
          action: "create",
        },
      });
    }
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  toContactDetails(e, data) {
    let allActiveState = {
      contactId: data.id,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ allActiveState })
    );
    this.props.navigate("/contact", {
      state: {
        action: "view",
        pageId: "AllActives",
        contactId: data.id,
        groupId: this.state.groupId,
        smsContactList: this.state.smsContactList,
      },
    });
  }

  onCheckBoxSelect(e, rowData, index) {
    const { isCtrlPressed, isShiftPressed } = this.state;
    const statusMap = {
      OptIn: { listKey: "activeContactListArr", allKey: "allOptinSelected" },
      InActive: { listKey: "inActiveContactListArr", allKey: "allInactiveSelected" },
      OptOut: { listKey: "optOutContactListArr", allKey: "allOptoutSelected" },
      Invalid: { listKey: "invalidContactListArr", allKey: "allInvalidSelected" },
    };

    const statusEntry = statusMap[rowData.status] || statusMap.Invalid;
    const selectedItems = [...this.state[statusEntry.listKey]];

    if (isCtrlPressed || isShiftPressed) {
      let firstItemIndex = selectedItems.findIndex((item) => item.checked);
      let lastItem = index;

      if (firstItemIndex === -1) firstItemIndex = lastItem;

      if (firstItemIndex > lastItem) {
        [firstItemIndex, lastItem] = [lastItem, firstItemIndex];
      }

      for (let i = firstItemIndex; i <= lastItem; i++) {
        selectedItems[i].checked = true;
      }
    } else {
      const item = selectedItems.find((item) => item.id === rowData.id);
      if (item) {
        item.checked = e.target.checked;
        if (!e.target.checked) {
          this.setState({ [statusEntry.allKey]: false });
        }
      }
    }

    const allChecked = selectedItems.every((item) => item.checked);
    const anyChecked = selectedItems.some((item) => item.checked);

    this.setState({
      [statusEntry.listKey]: selectedItems,
      [statusEntry.allKey]: allChecked,
      isSelected: anyChecked,
    });
  } s

  onAllOptinCheckBoxSelect(e) {
    let isChecked = e.target.checked;
    let dataRows = this.state.activeContactListArr;
    for (let i = 0; i < dataRows.length; i++) {
      const row = dataRows[i];
      this.onCheckBoxSelect(e, row, i);
    }
    this.setState({
      allOptinSelected: isChecked,
    });
  }

  onAllInactiveCheckBoxSelect(e) {
    let isChecked = e.target.checked;
    let dataRows = this.state.inActiveContactListArr;
    for (let i = 0; i < dataRows.length; i++) {
      const row = dataRows[i];
      this.onCheckBoxSelect(e, row, i);
    }
    this.setState({
      allInactiveSelected: isChecked,
    });
  }

  onAllOptoutCheckBoxSelect(e) {
    let isChecked = e.target.checked;
    let dataRows = this.state.optOutContactListArr;
    for (let i = 0; i < dataRows.length; i++) {
      const row = dataRows[i];
      this.onCheckBoxSelect(e, row, i);
    }
    this.setState({
      allOptoutSelected: isChecked,
    });
  }

  onAllInvalidCheckBoxSelect(e) {
    let isChecked = e.target.checked;
    let dataRows = this.state.invalidContactListArr;
    for (let i = 0; i < dataRows.length; i++) {
      const row = dataRows[i];
      this.onCheckBoxSelect(e, row, i);
    }
    this.setState({
      allInvalidSelected: isChecked,
    });
  }

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleAccountDropdownOpen = (e) => {
    this.getGroupList();
    this.setState({ anchorEl: e.currentTarget });
  };
  handleImportDropdownClose = () => {
    this.setState({ openImport: false, anchorElImport: null });
  };

  handleImportDropdownOpen = (e) => {
    this.setState({ openImport: true, anchorElImport: e.currentTarget });
  };

  handleGroupNameChange(selectedValue) {
    this.setState({ groupName: selectedValue, groupId: selectedValue?.id });
  }

  addContactsToGroup() {
    let addSmsContactList = [];
    if (this.state.selectedTab === 0) {
      for (let i = 0; i < this.state.activeContactListArr.length; i++) {
        if (this.state.smsContactList[i].checked === true) {
          addSmsContactList.push({ id: this.state.activeContactListArr[i].id });
        }
      }
    } else if (this.state.selectedTab === 1) {
      for (let i = 0; i < this.state.inActiveContactListArr.length; i++) {
        if (this.state.inActiveContactListArr[i].checked === true) {
          addSmsContactList.push({
            id: this.state.inActiveContactListArr[i].id,
          });
        }
      }
    } else if (this.state.selectedTab === 2) {
      for (let i = 0; i < this.state.optOutContactListArr.length; i++) {
        if (this.state.optOutContactListArr[i].checked === true) {
          addSmsContactList.push({ id: this.state.optOutContactListArr[i].id });
        }
      }
    } else if (this.state.selectedTab === 3) {
      for (let i = 0; i < this.state.invalidContactListArr.length; i++) {
        if (this.state.invalidContactListArr[i].checked === true) {
          addSmsContactList.push({
            id: this.state.invalidContactListArr[i].id,
          });
        }
      }
    }
    const postObject = {
      header: this.header,
      smsGroup: {
        id: this.state.groupId,
      },
      smsContactList: addSmsContactList,
    };
    FetchServerData.callPostService(AddContactsToGroup_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getAllContactList(this.state.selectedTab);
          this.setState({ groupName: null });
        } else {
        }
      }
    );
  }

  checkCSVFilekHandler(e) {
    this.setState({ checkCSVFile: e.target.checked });
  }

  onFileChange = (event) => {
    this.setState({ selectedFile: event.target.files[0] });
  };

  excelImportContactToGroup = (e) => {
    if (
      !this.state.selectedFile?.name ||
      this.state.selectedFile?.name === ""
    ) {
      PtsAlert.error("Please select file to upload");
      return;
    }
    let header = store.getState().header.header;
    const formData = new FormData();

    formData.append(
      "file",
      this.state.selectedFile,
      this.state.selectedFile.name
    );
    formData.append("sessionid", header.sessionid);
    formData.append("tid", header.tid);
    formData.append("userid", header.userid);
    formData.append("appclient", header.appclient);
    formData.append("isAp", header.isAp);
    FetchServerData.callPostFileUpload(ImportContacts_Url, formData).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.fileUploadRef.current.value = "";
          this.getAllContactList(this.state.selectedTab);
        }
      }
    );
  };

  excelDownloadContacts(contactStatus) {
    const postObject = {
      header: this.header,
      contactStatus: contactStatus,
      eventId: this.businessDomainId,
    };

    FetchServerData.callPostService(ExportSmsContacts_Url, postObject).then(
      (output) => {
        let AllContactExcelData = output.data;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          const byteArray = new Buffer(
            AllContactExcelData.data.replace(/^.+base64,/, ""),
            "base64"
          );
          const outputFilename = AllContactExcelData.filename;
          const url = URL.createObjectURL(new Blob([byteArray]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", outputFilename);
          document.body.appendChild(link);
          link.click();
        } else {
        }
      }
    );
  }

  getViewGroupList(contactId) {
    const postObject = {
      header: this.header,
      smsContact: {
        id: contactId,
      },
      eventId: this.businessDomainId,
    };

    FetchServerData.callPostService(GetGroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsContact = output.data.smsContact;
          let smsGroupList = output.data.groupList;
          for (let i = 0; i < smsGroupList.length; i++) {
            smsGroupList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(smsGroupList[i].createdOn) : Utils.getUtcToLocal(
              smsGroupList[i].createdOn
            );
          }
          this.setState({
            render: true,
            openViewGroup: true,
            contactId: smsContact.id,
            mobileNo: smsContact.mobile,
            firstName: smsContact.firstName,
            lastName: smsContact.lastName,
            email: smsContact.email,
            smsGroupList: smsGroupList,
          });
        } else {
        }
      }
    );
  }

  handleViewGroupOpen() {
    this.setState({ openViewGroup: true });
  }

  handleViewGroupClose() {
    this.setState({ openViewGroup: false });
  }

  // editContactDetails(e, data) {
  //   let allActiveState = {
  //     contactId: data.id,
  //     initialPage: this.state.initialPage,
  //     pageSize: this.state.pageSize,
  //     selectedTab: this.state.selectedTab,
  //   };
  //   store.dispatch(
  //     ApplicationStateAction.setApplicationState({ allActiveState })
  //   );

  //   if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
  //     this.props.navigate("/eventContact", {
  //       state: {
  //         action: "edit",
  //         contactId: data.id,
  //         pageId: "AllActives",
  //       },
  //     });
  //   } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
  //     this.props.navigate("/dptextContact", {
  //       state: {
  //         action: "edit",
  //         contactId: data.id,
  //         pageId: "AllActives",
  //       },
  //     });
  //   } else {
  //     this.props.navigate("/contact", {
  //       state: {
  //         action: "edit",
  //         contactId: data.id,
  //         pageId: "AllActives",
  //       },
  //     });
  //   }
  // }

  editContactDetails(data) {
    let mobileNo = Utils.phoneNumberFormate(data.mobile);
    this.setState({
      openEditContact: true,
      action: "view",
      pageId: "editContact",
      mobileNo: mobileNo,
      mobile: data.mobile,
      countryCode: data.countryCode,
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.email,
      contactId: data.id,
    });
  }
  handleEditContactClose() {
    this.setState({
      openEditContact: false,
    });
  }

  handleMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      let mobile = e.target.value.replace(/-/g, "");
      if (mobile.length === 10) {
        this.searchExistingMobileNo(value);
      }
      this.setState({
        mobileNo: value,
        mobile: mobile,
      });
    }
  }

  handleCountryChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
    });
  }
  searchExistingMobileNo(mobileNo) {
    const postObject = {
      header: this.header,
      smsContact: {
        mobile: mobileNo,
        countryCode: this.state.countryCode,
      },
    };
    if (
      !Utils.isNullOrEmpty(this.state.mobileNo) &&
      this.state.mobileNo.length >= 10
    ) {
      FetchServerData.callPostService(FindByNumber_Url, postObject).then(
        (output) => {
          if (output.status === "SUCCESS") {
            let smsContact = output.data.smsContact;
            this.setState({
              firstName: smsContact?.firstName,
              lastName: smsContact?.lastName,
              email: smsContact?.email,
            });
          } else {
          }
        }
      );
    }
  }

  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  updateContactToBackend() {
    const postObject = {
      header: this.header,
      smsContact: {
        mobile: this.state.mobile?.replace(/-/g, ""),
        countryCode: this.state.countryCode,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        // isOptin: this.state.isOptin,
        id: this.state.contactId,
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService(UpdateContact_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getAllContactList(
            this.state.selectedTab,
            this.state.pageNo,
            this.state.pageSize
          );
          this.setState({
            openEditContact: false,
          });
        } else {
        }
      }
    );
  }

  showActionButton(rowData) {
    return (
      <>
        <div style={{ display: "inline-flex" }}>
          {this.state.getUpdatePermission &&
            <>
              {(Utils.equalsIgnoreCase(rowData.status, "OptIn") ||
                Utils.equalsIgnoreCase(rowData.status, "InActive")) && (
                  <span className="me-2" style={{ cursor: "pointer" }} key={rowData.id} onClick={() => this.editContactDetails(rowData)}>
                    <EditButton />
                  </span>
                )}
            </>
          }
          {rowData.groupCount > 0 ? (
            <Tooltip
              title="Groups Belonging To"
              classes={{ popper: "custom-tooltip" }}
              arrow
            >
              <a
                href="#"
                style={{ cursor: "pointer", color: "#337ab7" }}
                onClick={this.getViewGroupList.bind(this, rowData.id)}
              >
                <i
                  className="menu-icon tf-icons fas fa-users"
                  style={{
                    color: "#6A7B8E",
                    fontSize: "19px",
                    padding: "3px",
                  }}
                ></i>
              </a>
            </Tooltip>
          ) : (
            <div style={{ width: "32px" }}></div>
          )}
          {(this.state.getDeletePermission && !this.state.isSelected) && (
            <span className="ms-1" style={{ cursor: "pointer" }}>
              <DeleteButton
                domainObject={rowData.status}
                onClick={this.deleteContactToBackend.bind(this, rowData)}
                pageId="Contact"
              />
            </span>
          )}
          {/* {Utils.equalsIgnoreCase(rowData.status, "Optin") ? (
            <div>
              <i
                className="fa fa-circle ms-4 mt-2"
                style={{ color: "green", fontSize: "small" }}
                aria-hidden="true"
              ></i>
            </div>
          ) : (
            <div></div>
          )}
          {Utils.equalsIgnoreCase(rowData.status, "InActive") && (
            <i
              className="fa fa-circle ms-4 mt-2"
              style={{ color: "yellow", fontSize: "small" }}
              aria-hidden="true"
            ></i>
          )}
          {Utils.equalsIgnoreCase(rowData.status, "OptOut") && (
            <i
              className="fa fa-circle ms-4 mt-2"
              style={{ color: "red", fontSize: "small" }}
              aria-hidden="true"
            ></i>
          )} */}
        </div>
      </>
    );
  }

  toGroupDetails(e, data) {
    this.props.navigate("/group", {
      state: {
        action: "view",
        groupId: data.id,
        pageId: "AllActiveContact",
      },
    });
  }

  setKey(tab) {
    const tabPaginationMap = {
      0: this.optinPaginationState,
      1: this.paindingPaginationState,
      2: this.optoutPaginationState,
      3: this.invalidPaginationState,
    };

    const paginationState = tabPaginationMap[tab] || {};

    const pageSize = paginationState?.pageSize ?? 100;
    const sortColumn = paginationState?.sortColumn ?? null;
    const isAscSort = paginationState?.isAscSort ?? false;
    this.getAllContactList(tab, this.state.pageNo, pageSize, sortColumn, isAscSort);

    this.setState({
      render: true,
      isDatanotfound: false,
      selectedTab: tab,
      totalRecords: 0,
      pageNo: 0,
      pageSize: pageSize,
      isSelected: false,
      allOptinSelected: false,
      allInactiveSelected: false,
      allOptoutSelected: false,
      allInvalidSelected: false,
    });
  }

  deleteContactToBackend(data) {
    const postObject = {
      header: this.header,
      smsContact: {
        id: data.id,
      },
      eventId: this.businessDomainId,
    };

    FetchServerData.callPostService(DeleteContact_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getAllContactList(
            this.state.selectedTab,
            this.state.pageNo,
            this.state.pageSize,
            this.state.sortColumn, this.state.isAscSort
          );
        } else {
        }
      })
      .catch((error) => { });
  }

  updateRecordsFromNeon() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(neonCrmSyncContacts_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getAllContactList(
            this.state.selectedTab,
            this.state.pageNo,
            this.state.pageSize
          );
        } else {
        }
      }
    );
  }
  updateRecordsFromBlackbaud() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      blackbaudCrmSyncContacts_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.getAllContactList(
          this.state.selectedTab,
          this.state.pageNo,
          this.state.pageSize
        );
      } else {
      }
    });
  }
  updateRecordsFromDPText() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(DPTextCrmSyncContacts_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getAllContactList(
            this.state.selectedTab,
            this.state.pageNo,
            this.state.pageSize
          );
        } else {
        }
      }
    );
  }

  addNewContact() {
    this.props.navigate("/contact", {
      state: {
        action: "create",
      },
    });
  }

  deleteContactToGroup(data) {
    const postObject = {
      header: this.header,
      smsGroupContact: {
        smsGroup: {
          id: data.id,
        },
        smsContact: {
          id: this.state.contactId,
        },
      },
    };

    FetchServerData.callPostService(DeleteContactFromGroup_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let smsGroup = output.data.smsGroup;
          let smsGroups = [];
          for (let i = 0; i < this.state.smsGroupList.length; i++) {
            const element = this.state.smsGroupList[i];
            if (element.id !== smsGroup.id) {
              smsGroups.push(smsGroup);
            }
          }
          this.getAllContactList(this.state.selectedTab);
          this.setState({
            smsGroupList: smsGroups,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  deleteMultipleContact() {
    let deleteSmsContactList = [];
    if (this.state.selectedTab === 0) {
      for (let i = 0; i < this.state.activeContactListArr.length; i++) {
        if (this.state.activeContactListArr[i].checked === true) {
          deleteSmsContactList.push(this.state.activeContactListArr[i].id);
        }
      }
    } else if (this.state.selectedTab === 1) {
      for (let i = 0; i < this.state.inActiveContactListArr.length; i++) {
        if (this.state.inActiveContactListArr[i].checked === true) {
          deleteSmsContactList.push(this.state.inActiveContactListArr[i].id);
        }
      }
    } else if (this.state.selectedTab === 3) {
      for (let i = 0; i < this.state.invalidContactListArr.length; i++) {
        if (this.state.invalidContactListArr[i].checked === true) {
          deleteSmsContactList.push(this.state.invalidContactListArr[i].id);
        }
      }
    } else {
      for (let i = 0; i < this.state.optOutContactListArr.length; i++) {
        if (this.state.optOutContactListArr[i].checked === true) {
          deleteSmsContactList.push(this.state.optOutContactListArr[i].id);
        }
      }
    }

    const postObject = {
      header: this.header,
      contactStatus: {
        id: this.state.selectedTab + 1,
      },
      idList: deleteSmsContactList,
      event: { id: this.businessDomainId },
    };
    FetchServerData.callPostService(
      "/smscontactms/deleteMultiple",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let smsContactList = output.data.smsContactList;
        PtsAlert.success(output.message);
        this.getAllContactList(
          this.state.selectedTab,
          this.state.pageNo,
          this.state.pageSize
        );
        this.setState({
          isSelected: false,
          isContactConfirmBoxOpen: false,
          smsContactList: smsContactList,
        });
      }
    });
  }

  handleDownloadReportClose() {
    this.setState({
      isDownloadReport: false,
    });
  }
  handleDownloadReportOpen() {
    this.setState({
      isDownloadReport: true,
    });
  }
  handleDeleteContactsOpen() {
    this.setState({
      isContactConfirmBoxOpen: true,
    });
  }
  handleDeleteContactsClose() {
    this.setState({
      isContactConfirmBoxOpen: false,
    });
  }

  handleRowClick = (e, rowData, index) => {
    if (e.target.closest(".action-button")) return; // Skip if clicking action button

    const { isCtrlPressed, isShiftPressed } = this.state;

    // Determine list key and allSelected key based on status
    let listKey = "";
    let allSelectedKey = "";

    switch (rowData.status) {
      case "OptIn":
        listKey = "activeContactListArr";
        allSelectedKey = "allOptinSelected";
        break;
      case "InActive":
        listKey = "inActiveContactListArr";
        allSelectedKey = "allInactiveSelected";
        break;
      case "OptOut":
        listKey = "optOutContactListArr";
        allSelectedKey = "allOptoutSelected";
        break;
      default:
        listKey = "invalidContactListArr";
        allSelectedKey = "allInvalidSelected";
    }

    let selectedItems = [...this.state[listKey]];

    if (isCtrlPressed || isShiftPressed) {
      // Multi-select range logic
      const firstItemIndex = selectedItems.findIndex((item) => item.checked);
      let lastItemIndex = index;

      if (firstItemIndex !== -1) {
        // Swap if needed
        const [start, end] =
          firstItemIndex < lastItemIndex
            ? [firstItemIndex, lastItemIndex]
            : [lastItemIndex, firstItemIndex];

        for (let i = start; i <= end; i++) {
          selectedItems[i].checked = true;
        }
      } else {
        // If no first checked item, just toggle current row
        selectedItems[index].checked = !selectedItems[index].checked;
      }
    } else {
      // Toggle single row selection
      selectedItems[index].checked = !selectedItems[index].checked;
    }

    // Calculate overall selection states
    const allChecked = selectedItems.every((item) => item.checked);
    const anyChecked = selectedItems.some((item) => item.checked);

    this.setState({
      [listKey]: selectedItems,
      [allSelectedKey]: allChecked,
      isSelected: anyChecked,
    });
  };

  // handleSort(column) {
  //   const {
  //     sortColumn,
  //     sortDirection,
  //     activeContactListArr,
  //     inActiveContactListArr,
  //     optOutContactListArr,
  //     invalidContactListArr,
  //   } = this.state;

  //   let newDirection = "asc";
  //   if (sortColumn === column && sortDirection === "asc") {
  //     newDirection = "desc";
  //   }

  //   this.setState({
  //     activeContactListArr: Utils.sortList(
  //       activeContactListArr,
  //       column,
  //       newDirection
  //     ),
  //     inActiveContactListArr: Utils.sortList(
  //       inActiveContactListArr,
  //       column,
  //       newDirection
  //     ),
  //     optOutContactListArr: Utils.sortList(
  //       optOutContactListArr,
  //       column,
  //       newDirection
  //     ),
  //     invalidContactListArr: Utils.sortList(
  //       invalidContactListArr,
  //       column,
  //       newDirection
  //     ),
  //     sortColumn: column,
  //     sortDirection: newDirection,
  //   });
  // }

  handleSort(column) {
    const { sortColumn, sortDirection, selectedTab, pageNo, pageSize } =
      this.state;

    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
    const isAscSort = newDirection === "asc";
    const contactsState = {
      pageSize,
      sortColumn: column,
      isAscSort,
    };
    if (selectedTab === 0) {
      store.dispatch(
        PaginationRowAction.setOptinsPaginationState({ optinContactsState: contactsState })
      );
    } else if (selectedTab === 1) {
      store.dispatch(
        PaginationRowAction.setPaindingPaginationState({ paindingContactsState: contactsState })
      );
    } else if (selectedTab === 2) {
      store.dispatch(
        PaginationRowAction.setOptoutPaginationState({ optoutContactsState: contactsState })
      );
    } else {
      store.dispatch(
        PaginationRowAction.setInvalidPaginationState({ invalidContactsState: contactsState })
      );
    }

    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort,
      },
      () => {
        this.getAllContactList(
          selectedTab,
          pageNo,
          pageSize,
          column,
          isAscSort
        );
      }
    );
  }

  renderSortIcon(column) {
    if (this.state.sortColumn !== column) return null;

    return this.state.sortDirection === "asc" ? (
      <i className="fa fa-long-arrow-up ps-1" aria-hidden="true"></i>
    ) : (
      <i className="fa-solid fa-arrow-down-long ps-1"></i>
    );
  }

  render() {
    let checkedContactCount = 0;
    if (this.state.selectedTab === 0) {
      checkedContactCount = this.state.activeContactListArr?.filter(
        (item) => item?.checked === true
      )?.length;
    } else if (this.state.selectedTab === 1) {
      checkedContactCount = this.state.inActiveContactListArr?.filter(
        (item) => item?.checked === true
      )?.length;
    } else if (this.state.selectedTab === 2) {
      checkedContactCount = this.state.optOutContactListArr?.filter(
        (item) => item?.checked === true
      )?.length;
    } else {
      checkedContactCount = this.state.invalidContactListArr?.filter(
        (item) => item?.checked === true
      )?.length;
    }

    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
        />
        <Menu
          anchorEl={this.state.anchorEl}
          id="dropdown-menu"
          className="filterDropdownMenu"
          open={this.state.open}
          onClose={this.handleAccountDropdownClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 20,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <div
            className="dropdown-item"
            style={{ cursor: "pointer", width: "500px", height: "100%" }}
          >
            <div className="row p-2">
              <h5>Add selected opt-ins to a group</h5>
              <div className="col-md-9 mt-1" id="assetFormLabel">
                <label
                  className="MuiAutocomplete-label form-label"
                  htmlFor="collapsible-supplierType"
                >
                  Choose Group
                </label>
                <Autocomplete
                  id="size-small-outlined"
                  size="small"
                  fullWidth
                  disableClearable
                  autoComplete="off"
                  ListboxProps={{
                    className: "custom-listbox",
                  }}
                  options={this.state.smsGroupList}
                  value={this.state.groupName}
                  getOptionLabel={(option) => option.name}
                  defaultValue={this.state.groupName}
                  onChange={(event, value) => {
                    this.handleGroupNameChange(value);
                  }}
                  inputprops={{ style: { textTransform: "capitalize" } }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Please Select"
                      variant="outlined"
                      size="small"
                      className="autoComplete"
                      required
                      title=""
                      style={{ background: "#fff" }}
                    />
                  )}
                />
              </div>
              <div className="col-md-3" style={{ marginTop: "32px" }}>
                <PtsButton
                  btnName="Add"
                  onClick={this.addContactsToGroup.bind(this)}
                />
              </div>
            </div>
          </div>
        </Menu>
        <Menu
          anchorEl={this.state.anchorElImport}
          id="dropdown-menu"
          className="filterDropdownMenu"
          open={this.state.openImport}
          onClose={this.handleImportDropdownClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 20,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <div
            className="dropdown-item"
            style={{ width: "600px", height: "100%" }}
          >
            <div className="row p-2">
              <h5 style={{ color: "#1957b4" }}>
                <b>Import Contacts</b>
              </h5>
              <div className="row mt-2">
                <div
                  className="col-sm-6"
                  style={{ display: "inline-block", cursor: "pointer" }}
                >
                  <input
                    type="file"
                    name="file"
                    id="file"
                    multiple
                    ref={this.fileUploadRef}
                    onChange={this.onFileChange.bind(this)}
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12" style={{ marginTop: "1em" }}>
                  <p
                    id="givbeeText"
                    style={{ textWrap: "wrap", textAlign: "justify" }}
                  >
                    <span className="me-2">
                      <input
                        type="checkbox"
                        checked={this.state.checkCSVFile}
                        onChange={this.checkCSVFilekHandler.bind(this)}
                        required
                      />
                    </span>
                    On behalf of Proto Technology Solutions, I verify that all
                    of the people included on the selected import file have
                    given their permission to add their mobile number to the
                    opt-in list.
                  </p>
                </div>
              </div>
              <div className="row ms-1 mt-3">
                {this.state.checkCSVFile ? (
                  <button
                    className="btn btn-primary"
                    style={{ width: "120px", cursor: "pointer" }}
                    onClick={this.excelImportContactToGroup.bind(this)}
                  >
                    {" "}
                    Import
                  </button>
                ) : (
                  <button
                    disabled
                    className="btn btn-primary"
                    style={{ width: "120px", cursor: "pointer" }}
                  >
                    {" "}
                    Import
                  </button>
                )}
              </div>
            </div>
          </div>
        </Menu>
        <div style={{ maxWidth: "100%" }}>
          <Tabs
            defaultIndex={this.state.selectedTab}
            onSelect={(k) => this.setKey(k)}
          >
            <TabList
              style={{ listStyle: "none" }}
              className="text-start d-flex flex-wrap justify-content-start settingTabList ps-0 m-0"
            >
              <>
                <Tab className="tabContacts hoverTab">Opt-ins</Tab>
                <Tab className="tabContacts hoverTab">Pending</Tab>
                <Tab className="tabContacts hoverTab">Opt-outs</Tab>
                <Tab className="tabContacts hoverTab">Invalids</Tab>
                <div className="row" style={{ alignContent: "end", marginLeft: "auto" }}>
                  {this.state.searchText !== "" &&
                    <span
                      style={{
                        color: "red",
                        fontWeight: "700",
                        cursor: "pointer",
                        fontSize: "12px",
                      }}
                    >
                      Search results are being displayed.
                    </span>
                  }
                </div>
              </>
            </TabList>
            <TabPanel>
              <div className="row">
                <div className="col">
                  <div className="col md-12">
                    <div className="card rounded-0 cardTopBoxShadowremove">
                      <div
                        className="row justify-content-between"
                        style={{ padding: "0.6em 1.2rem" }}
                      >
                        <div
                          // className={
                          //   this.businessDomain === BUSINESS_DOMAIN.eventText
                          //     ? "d-flex col-12 col-lg-7 col-xl-7"
                          //     : "d-flex col-12 col-lg-5 col-xl-5"
                          // }
                          className="d-flex col-12 col-lg-5 col-xl-5 p-0"
                        >
                          <div className="col-12 d-flex align-self-center pe-0">
                            <span className="fs-8">
                              {(this.state.totalRecords !== 0 || this.state.isDatanotfound) ? `You have ${this.state.totalRecords} active recipients on your Opt-ins list.` : ""}
                            </span>
                          </div>
                        </div>
                        <div
                          // className={
                          //   this.businessDomain === BUSINESS_DOMAIN.eventText
                          //     ? "d-flex col-12 col-lg-5 col-xl-5"
                          //     : "d-flex col-12 col-lg-7 col-xl-7"
                          // }
                          className="d-flex col-12 col-lg-7 col-xl-7"
                        >
                          <div className="col-sm-9 text-end align-self-end">
                            <>
                              {this.state.isSelected ? (
                                <>
                                  <span className="me-2">
                                    <Button
                                      id="ptsHollowButton"
                                      variant="contained"
                                      type="submit"
                                      className="btn btn-default "
                                      startIcon={
                                        <i
                                          className="fa-regular fa-trash-can"
                                          aria-hidden="true"
                                          style={{
                                            borderRadius: "25%",
                                            color: "#23527c",
                                            fontSize: "16px",
                                            width: "30px",
                                            minHeight: "22px",
                                            padding: "3px",
                                            alignContent: "center",
                                            textAlign: "center",
                                            fontWeight: "600",
                                          }}
                                        ></i>
                                      }
                                      onClick={this.handleDeleteContactsOpen.bind(
                                        this
                                      )}
                                    >
                                      Delete contacts
                                    </Button>
                                  </span>
                                  <span className="me-2">
                                    <>
                                      <Button
                                        id="ptsHollowButton"
                                        style={{ textTransform: "initial" }}
                                        variant="contained"
                                        className="btn btn-default "
                                        onClick={this.handleAccountDropdownOpen}
                                      >
                                        Add Selected to Group
                                      </Button>
                                    </>
                                  </span>
                                </>
                              ) :
                                <>
                                  {this.state.isNeonIntegration && (
                                    <span className="me-2">
                                      <Button
                                        id="ptsHollowButton"
                                        variant="contained"
                                        className="btn-default "
                                        onClick={(e) => this.updateRecordsFromNeon()}
                                      >
                                        Update records from Neon
                                      </Button>
                                    </span>
                                  )}
                                  {this.state.isBlackbaudIntegration && (
                                    <span className="me-2">
                                      <Button
                                        id="ptsHollowButton"
                                        variant="contained"
                                        className="btn-default "
                                        onClick={(e) =>
                                          this.updateRecordsFromBlackbaud()
                                        }
                                      >
                                        Update records from Re NXT
                                      </Button>
                                    </span>
                                  )}
                                  {this.state.isDpTextIntegration && (
                                    <span className="me-2">
                                      <Button
                                        id="ptsHollowButton"
                                        variant="contained"
                                        className="btn-default "
                                        onClick={(e) =>
                                          this.updateRecordsFromDPText()
                                        }
                                      >
                                        Update records from DonorPerfect
                                      </Button>
                                    </span>
                                  )}
                                </>
                              }
                              {this.state.activeContactListArr.length > 0 && (
                                <span className="me-3">
                                  {this.state.getReportPermission === true ? (
                                    <Button
                                      id="downloadReportButton"
                                      variant="contained"
                                      type="button"
                                      startIcon={
                                        <i
                                          className="fa fa-download"
                                          style={{ fontSize: "16px" }}
                                        ></i>
                                      }
                                      onClick={this.excelDownloadContacts.bind(
                                        this,
                                        "OptIn"
                                      )}
                                    >
                                      Download Report
                                    </Button>
                                  ) : (
                                    <Button
                                      id="downloadReportButton"
                                      variant="contained"
                                      type="button"
                                      startIcon={
                                        <i
                                          className="fa fa-download"
                                          style={{ fontSize: "16px" }}
                                        ></i>
                                      }
                                      onClick={this.handleDownloadReportOpen.bind(
                                        this
                                      )}
                                    >
                                      Download Report
                                    </Button>
                                  )}
                                </span>
                              )}
                            </>
                          </div>
                          <div className="col-sm-3 text-end d-flex align-self-end">
                            <TextField
                              id="standard-search"
                              placeholder="Search"
                              type="text"
                              variant="standard"
                              value={this.state.searchText}
                              onChange={this.onSearchChange.bind(this)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton
                                      onClick={this.getAllContactList.bind(
                                        this,
                                        this.state.selectedTab,
                                        this.state.pageNo,
                                        this.state.pageSize
                                      )}
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => {
                                        this.setState(
                                          { searchText: "" },
                                          () => {
                                            this.getAllContactList(
                                              this.state.selectedTab,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            );
                                          }
                                        );
                                      }}
                                      disabled={!this.state.searchText}
                                    >
                                      <ClearIcon
                                        style={{
                                          opacity: this.state.searchText
                                            ? 1
                                            : 0.4,
                                          fontSize: "1.25rem",
                                          color: "353538",
                                        }}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive paginationTable">
                        <table className="table text-start table-hover">
                          <thead className="paginationTableThead">
                            <tr>
                              <th scope="col fw-bold" style={{ width: "5%" }}>
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    marginTop: "6px",
                                  }}
                                  checked={this.state.allOptinSelected}
                                  onChange={this.onAllOptinCheckBoxSelect.bind(
                                    this
                                  )}
                                />
                              </th>
                              <th scope="col fw-bold" style={{ cursor: "pointer", width: "16%" }}
                                onClick={() => this.handleSort("mobile")}>Mobile Number
                                {this.state.sortColumn === "mobile" &&
                                  (this.state.sortDirection === "asc" ? (
                                    <i
                                      class="fa fa-long-arrow-up ps-1"
                                      aria-hidden="true"
                                    ></i>
                                  ) : (
                                    <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                  ))}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ cursor: "pointer", width: "15%" }}
                                onClick={() => this.handleSort("firstName")}
                              >
                                First Name
                                {this.renderSortIcon("firstName")}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ cursor: "pointer", width: "15%" }}
                                onClick={() => this.handleSort("lastName")}
                              >
                                Last Name
                                {this.renderSortIcon("lastName")}
                              </th>
                              <th className="cursor-pointer" scope="col fw-bold" style={{ width: "18%" }} onClick={() => this.handleSort("email")}>
                                Email
                                {this.renderSortIcon("email")}
                              </th>
                              <th className="cursor-pointer" scope="col fw-bold" style={{ width: "18%" }} onClick={() => this.handleSort("lastMessageSenton")}>
                                Last Message Sent
                                {this.renderSortIcon("lastMessageSenton")}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ width: "15%", textAlign: "center" }}
                              >
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.activeContactListArr?.map(
                              (rowData, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      rowData.id === this.state.contactId
                                        ? "#e6effc"
                                        : "",
                                  }}
                                >
                                  <td style={{ width: "50px" }}>
                                    <input
                                      type="checkbox"
                                      style={{
                                        width: "15px",
                                        height: "15px",
                                        marginTop: "6px",
                                        cursor: "pointer",
                                      }}
                                      checked={
                                        rowData.checked ||
                                        this.state.allOptinSelected
                                      }
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        this.onCheckBoxSelect(
                                          e,
                                          rowData,
                                          index
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{ width: "175px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {/* {this.state.getUpdatePermission ? (
                                      <span
                                        className="anchortag"
                                        onClick={(e) =>
                                          this.editContactDetails(e, rowData)
                                        }
                                      >
                                        {rowData.mobile}
                                      </span>
                                    ) : ( */}
                                    <span>{rowData.mobile}</span>
                                    {/* )} */}
                                  </td>
                                  <td
                                    style={{ width: "140px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.firstName}
                                  </td>
                                  <td
                                    style={{ width: "140px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.lastName}
                                  </td>
                                  <td
                                    style={{ width: "200px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.email}
                                  </td>
                                  <td
                                    style={{ width: "200px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.lastMessageSenton}
                                  </td>
                                  <td
                                    key={rowData.id}
                                    style={{
                                      width: "120px",
                                    }}
                                  >
                                    {this.showActionButton(rowData)}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                      {(this.state.totalRecords === 0) && (
                        <div
                          className="row text-center"
                          style={{ padding: "6px 20px" }}
                        >
                          <h5 className="dataNotAvailable">No data found.</h5>
                        </div>
                      )}
                      {this.state.totalRecords > 10 && (
                        <div className="row justify-content-between pagination p-1">
                          <div className="d-flex col-12 col-lg-5 col-xl-5">
                            <div className="pageSize col-12 text-start">
                              Page {this.state.pageNo + 1} of{" "}
                              {this.state.totalPages}
                            </div>
                          </div>
                          <div className="d-flex col-12 col-lg-2 col-xl-2">
                            <span className="pageSize me-4" style={{ fontSize: "14px" }}>
                              Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                            </span>
                          </div>
                          <div className="d-flex col-12 col-lg-5 col-xl-5">
                            <div className="col-12 text-end">
                              <Pagination
                                showPerPage={this.state.showPerPage}
                                onPaginationChange={this.onPaginationChange.bind(
                                  this
                                )}
                                total={this.state.totalRecords}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {this.state.activeContactListArr.length > 10 &&
                <div className="row mt-3 mb-3">
                  <div className="col-sm-12 text-center">
                    {this.state.isSelected && (
                      <>
                        <span className="me-2">
                          <Button
                            id="ptsHollowButton"
                            variant="contained"
                            type="submit"
                            className="btn btn-default "
                            startIcon={
                              <i
                                className="fa-regular fa-trash-can"
                                aria-hidden="true"
                                style={{
                                  borderRadius: "25%",
                                  color: "#23527c",
                                  fontSize: "16px",
                                  width: "30px",
                                  minHeight: "22px",
                                  padding: "3px",
                                  alignContent: "center",
                                  textAlign: "center",
                                  fontWeight: "600",
                                }}
                              ></i>
                            } onClick={this.handleDeleteContactsOpen.bind(
                              this
                            )}
                          >
                            Delete contacts
                          </Button>
                        </span>
                        <Button
                          id="ptsHollowButton"
                          style={{ textTransform: "initial" }}
                          variant="contained"
                          className="btn btn-default "
                          onClick={this.handleAccountDropdownOpen}
                        >
                          Add Selected to Group
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              }
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col">
                  <div className="col md-12">
                    <div className="card rounded-0 cardTopBoxShadowremove">
                      <div
                        className="row justify-content-between"
                        style={{ padding: "0.6em 1.2rem" }}
                      >
                        <div
                          // className={
                          //   this.businessDomain === BUSINESS_DOMAIN.eventText
                          //     ? "d-flex col-12 col-lg-7 col-xl-7"
                          //     : "d-flex col-12 col-lg-5 col-xl-5 pe-0"
                          // }
                          className="d-flex col-12 col-lg-5 col-xl-5 p-0"
                        >
                          <div className="col-12 d-flex text-start align-self-center pe-0">
                            <span className="fs-8">
                              {(this.state.totalRecords !== 0 || this.state.isDatanotfound) ? `These ${Utils.formatWithCommas(this.state.totalRecords)} numbers will be moved to your Opt-ins List once they receive a text message.` : ""}
                            </span>
                          </div>
                        </div>
                        <div
                          // className={
                          //   this.businessDomain === BUSINESS_DOMAIN.eventText
                          //     ? "d-flex col-12 col-lg-5 col-xl-5"
                          //     : "d-flex col-12 col-lg-7 col-xl-7"
                          // }
                          className="d-flex col-12 col-lg-7 col-xl-7"
                        >
                          <div className="col-sm-9 text-end  align-self-end">
                            {this.state.isSelected ? (
                              <span className="me-2">
                                <>
                                  <Button
                                    id="ptsHollowButton"
                                    variant="contained"
                                    style={{ textTransform: "initial" }}
                                    className="btn btn-default "
                                    onClick={this.handleAccountDropdownOpen}
                                  >
                                    Add Selected to Group
                                  </Button>
                                  &nbsp;&nbsp;&nbsp;
                                  <Button
                                    id="ptsHollowButton"
                                    variant="contained"
                                    type="submit"
                                    className="btn btn-default "
                                    startIcon={
                                      <i
                                        className="fa-regular fa-trash-can"
                                        aria-hidden="true"
                                        style={{
                                          borderRadius: "25%",
                                          color: "#23527c",
                                          fontSize: "16px",
                                          width: "30px",
                                          minHeight: "22px",
                                          padding: "3px",
                                          alignContent: "center",
                                          textAlign: "center",
                                          fontWeight: "600",
                                        }}
                                      ></i>
                                    } onClick={this.handleDeleteContactsOpen.bind(
                                      this
                                    )}
                                  >
                                    Delete contacts
                                  </Button>
                                </>
                              </span>
                            ) :
                              <>
                                {
                                  this.state.isNeonIntegration && (
                                    <span className="me-2">
                                      <Button
                                        id="ptsHollowButton"
                                        variant="contained"
                                        className="btn-default "
                                        onClick={(e) => this.updateRecordsFromNeon()}
                                      >
                                        Update records from Neon
                                      </Button>
                                    </span>
                                  )
                                }
                                {this.state.isBlackbaudIntegration && (
                                  <span className="me-2">
                                    <Button
                                      id="ptsHollowButton"
                                      variant="contained"
                                      className="btn-default "
                                      onClick={(e) =>
                                        this.updateRecordsFromBlackbaud()
                                      }
                                    >
                                      Update records from Re NXT
                                    </Button>
                                  </span>
                                )}
                                {this.state.isDpTextIntegration && (
                                  <span className="me-2">
                                    <Button
                                      id="ptsHollowButton"
                                      variant="contained"
                                      className="btn-default "
                                      onClick={(e) =>
                                        this.updateRecordsFromDPText()
                                      }
                                    >
                                      Update records from DonorPerfect
                                    </Button>
                                  </span>
                                )}

                              </>
                            }
                            {this.state.inActiveContactListArr?.length > 0 && (
                              <span className="me-3">
                                {this.state.getReportPermission === true ? (
                                  <Button
                                    id="downloadReportButton"
                                    variant="contained"
                                    type="button"
                                    startIcon={
                                      <i
                                        className="fa fa-download"
                                        style={{ fontSize: "16px" }}
                                      ></i>
                                    }
                                    onClick={this.excelDownloadContacts.bind(
                                      this,
                                      "InActive"
                                    )}
                                  >
                                    Download Report
                                  </Button>
                                ) : (
                                  <Button
                                    id="downloadReportButton"
                                    variant="contained"
                                    type="button"
                                    startIcon={
                                      <i
                                        className="fa fa-download"
                                        style={{ fontSize: "16px" }}
                                      ></i>
                                    }
                                    onClick={this.handleDownloadReportOpen.bind(
                                      this
                                    )}
                                  >
                                    Download Report
                                  </Button>
                                )}
                              </span>
                            )}
                          </div>
                          <div className="col-sm-3 text-end d-flex align-self-end">
                            <TextField
                              id="standard-search"
                              placeholder="Search"
                              type="text"
                              variant="standard"
                              value={this.state.searchText}
                              onChange={this.onSearchChange.bind(this)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton
                                      onClick={this.getAllContactList.bind(
                                        this,
                                        this.state.selectedTab,
                                        this.state.pageNo,
                                        this.state.pageSize
                                      )}
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => {
                                        this.setState(
                                          { searchText: "" },
                                          () => {
                                            this.getAllContactList(
                                              this.state.selectedTab,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            );
                                          }
                                        );
                                      }}
                                      disabled={!this.state.searchText}
                                    >
                                      <ClearIcon
                                        style={{
                                          opacity: this.state.searchText
                                            ? 1
                                            : 0.4,
                                          fontSize: "1.25rem",
                                          color: "353538",
                                        }}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive paginationTable">
                        <table className="table text-start table-hover">
                          <thead className="paginationTableThead">
                            <tr>
                              <th scope="col fw-bold" style={{ width: "5%" }}>
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    marginTop: "6px",
                                  }}
                                  checked={this.state.allInactiveSelected}
                                  onChange={this.onAllInactiveCheckBoxSelect.bind(
                                    this
                                  )}
                                />
                              </th>
                              <th scope="col fw-bold" style={{ cursor: "pointer", width: "16%" }}
                                onClick={() => this.handleSort("mobile")}>Mobile Number
                                {this.state.sortColumn === "mobile" &&
                                  (this.state.sortDirection === "asc" ? (
                                    <i
                                      class="fa fa-long-arrow-up ps-1"
                                      aria-hidden="true"
                                    ></i>
                                  ) : (
                                    <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                  ))}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ cursor: "pointer", width: "15%" }}
                                onClick={() => this.handleSort("firstName")}
                              >
                                First Name
                                {this.renderSortIcon("firstName")}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ cursor: "pointer", width: "15%" }}
                                onClick={() => this.handleSort("lastName")}
                              >
                                Last Name
                                {this.renderSortIcon("lastName")}
                              </th>
                              <th className="cursor-pointer" scope="col fw-bold" style={{ width: "18%" }} onClick={() => this.handleSort("email")}>
                                Email
                                {this.renderSortIcon("email")}
                              </th>
                              <th className="cursor-pointer" scope="col fw-bold" style={{ width: "18%" }} onClick={() => this.handleSort("lastMessageSenton")}>
                                Date Added
                                {this.renderSortIcon("createdOn")}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ width: "15%", textAlign: "center" }}
                              >
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.inActiveContactListArr?.map(
                              (rowData, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      rowData.id === this.state.contactId
                                        ? "#e6effc"
                                        : "",
                                  }}
                                >
                                  <td style={{ width: "50px" }}>
                                    <input
                                      type="checkbox"
                                      style={{
                                        width: "15px",
                                        height: "15px",
                                        marginTop: "6px",
                                      }}
                                      checked={
                                        rowData.checked ||
                                        this.state.allInactiveSelected
                                      }
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        this.onCheckBoxSelect(
                                          e,
                                          rowData,
                                          index
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{ width: "175px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {/* {this.state.getUpdatePermission ? (
                                      <span
                                        className="cursor-pointer"
                                        onClick={(e) =>
                                          this.editContactDetails(e, rowData)
                                        }
                                      >
                                        {rowData.mobile}
                                      </span>
                                    ) : ( */}
                                    <span>{rowData.mobile}</span>
                                    {/* )} */}
                                  </td>
                                  <td
                                    style={{ width: "140px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.firstName}
                                  </td>
                                  <td
                                    style={{ width: "140px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.lastName}
                                  </td>
                                  <td
                                    style={{ width: "200px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.email}
                                  </td>
                                  <td
                                    style={{ width: "200px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.createdOn}
                                  </td>
                                  <td
                                    className="action-button"
                                    style={{
                                      width: "120px",
                                    }}
                                    key={rowData.id}
                                  >
                                    {this.showActionButton(rowData)}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                      {(this.state.totalRecords === 0) && (
                        <div
                          className="row text-center"
                          style={{ padding: "6px 20px" }}
                        >
                          <h5 className="dataNotAvailable">No data found.</h5>
                        </div>
                      )}
                      {this.state.totalRecords > 10 && (
                        <div className="row justify-content-between pagination p-1">
                          <div className="d-flex col-12 col-lg-5 col-xl-5">
                            <div className="pageSize col-12 text-start">
                              Page {this.state.pageNo + 1} of{" "}
                              {this.state.totalPages}
                            </div>
                          </div>
                          <div className="d-flex col-12 col-lg-2 col-xl-2">
                            <span className="pageSize me-4" style={{ fontSize: "14px" }}>
                              Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                            </span>
                          </div>
                          <div className="d-flex col-12 col-lg-5 col-xl-5">
                            <div className="col-12 text-end">
                              <Pagination
                                showPerPage={this.state.showPerPage}
                                onPaginationChange={this.onPaginationChange.bind(
                                  this
                                )}
                                total={this.state.totalRecords}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {this.state.inActiveContactListArr.length > 10 &&
                <div className="row mt-3 mb-3">
                  <div className="col-sm-12 text-center">
                    {this.state.isSelected && (
                      <>
                        <Button
                          id="ptsHollowButton"
                          variant="contained"
                          style={{ textTransform: "initial" }}
                          className="btn btn-default "
                          onClick={this.handleAccountDropdownOpen}
                        >
                          Add Selected to Group
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button
                          id="ptsHollowButton"
                          variant="contained"
                          type="submit"
                          className="btn btn-default "
                          startIcon={
                            <i
                              className="fa-regular fa-trash-can"
                              aria-hidden="true"
                              style={{
                                borderRadius: "25%",
                                color: "#23527c",
                                fontSize: "16px",
                                width: "30px",
                                minHeight: "22px",
                                padding: "3px",
                                alignContent: "center",
                                textAlign: "center",
                                fontWeight: "600",
                              }}
                            ></i>
                          }
                          onClick={this.handleDeleteContactsOpen.bind(
                            this
                          )}
                        >
                          Delete contacts
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              }
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col">
                  <div className="col md-12">
                    <div className="card rounded-0 cardTopBoxShadowremove">
                      <div
                        className="row justify-content-between"
                        style={{ padding: "0.6em 1.2rem" }}
                      >
                        <div
                          // className={
                          //   this.businessDomain === BUSINESS_DOMAIN.eventText
                          //     ? "d-flex col-12 col-lg-7 col-xl-7"
                          //     : "d-flex col-12 col-lg-5 col-xl-5"
                          // }
                          className="d-flex col-12 col-lg-5 col-xl-5 p-0"
                        >
                          <div className="col-12 d-flex align-self-center">
                            <span className="fs-8">
                              {(this.state.totalRecords !== 0 || this.state.isDatanotfound) ? `These ${Utils.formatWithCommas(this.state.totalRecords)} numbers opted-out from your texting service.` : ""}
                            </span>
                          </div>
                        </div>
                        <div
                          // className={
                          //   this.businessDomain === BUSINESS_DOMAIN.eventText
                          //     ? "d-flex col-12 col-lg-5 col-xl-5"
                          //     : "d-flex col-12 col-lg-7 col-xl-7"
                          // }
                          className="d-flex col-12 col-lg-7 col-xl-7"
                        >
                          <div className="col-sm-9 text-end  align-self-end">
                            <span className="me-2">
                              {this.state.isSelected && (
                                <Button
                                  id="ptsHollowButton"
                                  variant="contained"
                                  type="submit"
                                  className="btn btn-default "
                                  startIcon={
                                    <i
                                      className="fa-regular fa-trash-can"
                                      aria-hidden="true"
                                      style={{
                                        borderRadius: "25%",
                                        color: "#23527c",
                                        fontSize: "16px",
                                        width: "30px",
                                        minHeight: "22px",
                                        padding: "3px",
                                        alignContent: "center",
                                        textAlign: "center",
                                        fontWeight: "600",
                                      }}
                                    ></i>
                                  } onClick={this.handleDeleteContactsOpen.bind(
                                    this
                                  )}
                                >
                                  Delete contacts
                                </Button>
                              )}
                            </span>
                            {this.state.optOutContactListArr.length > 0 && (
                              <span className="me-3">
                                {this.state.getReportPermission === true ? (
                                  <Button
                                    id="downloadReportButton"
                                    variant="contained"
                                    type="button"
                                    startIcon={
                                      <i
                                        className="fa fa-download"
                                        style={{ fontSize: "16px" }}
                                      ></i>
                                    }
                                    onClick={this.excelDownloadContacts.bind(
                                      this,
                                      "OptOut"
                                    )}
                                  >
                                    Download Report
                                  </Button>
                                ) : (
                                  <Button
                                    id="downloadReportButton"
                                    variant="contained"
                                    type="button"
                                    startIcon={
                                      <i
                                        className="fa fa-download"
                                        style={{ fontSize: "16px" }}
                                      ></i>
                                    }
                                    onClick={this.handleDownloadReportOpen.bind(
                                      this
                                    )}
                                  >
                                    Download Report
                                  </Button>
                                )}
                              </span>
                            )}
                          </div>
                          <div className="col-sm-3 text-end d-flex">
                            <TextField
                              id="standard-search"
                              placeholder="Search"
                              type="text"
                              variant="standard"
                              value={this.state.searchText}
                              onChange={this.onSearchChange.bind(this)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton
                                      onClick={this.getAllContactList.bind(
                                        this,
                                        this.state.selectedTab,
                                        this.state.pageNo,
                                        this.state.pageSize
                                      )}
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => {
                                        this.setState(
                                          { searchText: "" },
                                          () => {
                                            this.getAllContactList(
                                              this.state.selectedTab,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            );
                                          }
                                        );
                                      }}
                                      disabled={!this.state.searchText}
                                    >
                                      <ClearIcon
                                        style={{
                                          opacity: this.state.searchText
                                            ? 1
                                            : 0.4,
                                          fontSize: "1.25rem",
                                          color: "353538",
                                        }}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive paginationTable">
                        <table className="table text-start table-hover">
                          <thead className="paginationTableThead">
                            <tr>
                              <th scope="col fw-bold" style={{ width: "5%" }}>
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    marginTop: "6px",
                                  }}
                                  checked={this.state.allOptoutSelected}
                                  onChange={this.onAllOptoutCheckBoxSelect.bind(
                                    this
                                  )}
                                />
                              </th>
                              <th scope="col fw-bold" style={{ cursor: "pointer", width: "16%" }}
                                onClick={() => this.handleSort("mobile")}>Mobile Number
                                {this.state.sortColumn === "mobile" &&
                                  (this.state.sortDirection === "asc" ? (
                                    <i
                                      class="fa fa-long-arrow-up ps-1"
                                      aria-hidden="true"
                                    ></i>
                                  ) : (
                                    <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                  ))}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ cursor: "pointer", width: "15%" }}
                                onClick={() => this.handleSort("firstName")}
                              >
                                First Name
                                {this.renderSortIcon("firstName")}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ cursor: "pointer", width: "15%" }}
                                onClick={() => this.handleSort("lastName")}
                              >
                                Last Name
                                {this.renderSortIcon("lastName")}
                              </th>
                              <th className="cursor-pointer" scope="col fw-bold" style={{ width: "18%" }}>
                                Email
                                {this.renderSortIcon("email")}
                              </th>
                              <th className="cursor-pointer" scope="col fw-bold" style={{ width: "18%" }}>
                                Last Message Sent
                                {this.renderSortIcon("lastMessageSenton")}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ width: "15%", textAlign: "center" }}
                              >
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.optOutContactListArr?.map(
                              (rowData, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      rowData.id === this.state.contactId
                                        ? "#e6effc"
                                        : "",
                                  }}
                                >
                                  <td style={{ width: "50px" }}>
                                    <input
                                      type="checkbox"
                                      style={{
                                        width: "15px",
                                        height: "15px",
                                        marginTop: "6px",
                                      }}
                                      checked={
                                        rowData.checked ||
                                        this.state.allOptoutSelected
                                      }
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        this.onCheckBoxSelect(
                                          e,
                                          rowData,
                                          index
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{ width: "175px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {/* {this.state.getUpdatePermission ? (
                                      <span
                                        className="anchortag"
                                        onClick={(e) =>
                                          this.editContactDetails(e, rowData)
                                        }
                                      >
                                        {rowData.mobile}
                                      </span>
                                    ) : ( */}
                                    <span>{rowData.mobile}</span>
                                    {/* )} */}
                                  </td>
                                  <td
                                    style={{ width: "140px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.firstName}
                                  </td>
                                  <td
                                    style={{ width: "140px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.lastName}
                                  </td>
                                  <td
                                    style={{ width: "200px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.email}
                                  </td>
                                  <td
                                    style={{ width: "200px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.lastMessageSenton}
                                  </td>
                                  <td
                                    className="action-button"
                                    style={{
                                      width: "120px",
                                    }}
                                    key={rowData.id}
                                  >
                                    {this.showActionButton(rowData)}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                      {(this.state.totalRecords === 0) && (
                        <div
                          className="row text-center"
                          style={{ padding: "6px 20px" }}
                        >
                          <h5 className="dataNotAvailable">No data found.</h5>
                        </div>
                      )}
                      {this.state.totalRecords > 10 && (
                        <div className="row justify-content-between pagination p-1">
                          <div className="d-flex col-12 col-lg-5 col-xl-5">
                            <div className="pageSize col-12 text-start">
                              Page {this.state.pageNo + 1} of{" "}
                              {this.state.totalPages}
                            </div>
                          </div>
                          <div className="d-flex col-12 col-lg-2 col-xl-2">
                            <span className="pageSize me-4" style={{ fontSize: "14px" }}>
                              Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                            </span>
                          </div>
                          <div className="d-flex col-12 col-lg-5 col-xl-5">
                            <div className="col-12 text-end">
                              <Pagination
                                showPerPage={this.state.showPerPage}
                                onPaginationChange={this.onPaginationChange.bind(
                                  this
                                )}
                                total={this.state.totalRecords}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {this.state.optOutContactListArr.length > 10 &&
                <div className="row mt-3 mb-3">
                  <div className="col-sm-12 text-center">
                    {this.state.isSelected && (
                      <Button
                        id="ptsHollowButton"
                        variant="contained"
                        type="submit"
                        className="btn btn-default "
                        startIcon={
                          <i
                            className="fa-regular fa-trash-can"
                            aria-hidden="true"
                            style={{
                              borderRadius: "25%",
                              color: "#23527c",
                              fontSize: "16px",
                              width: "30px",
                              minHeight: "22px",
                              padding: "3px",
                              alignContent: "center",
                              textAlign: "center",
                              fontWeight: "600",
                            }}
                          ></i>
                        } onClick={this.handleDeleteContactsOpen.bind(
                          this
                        )}
                      >
                        Delete contacts
                      </Button>
                    )}
                  </div>
                </div>
              }
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col">
                  <div className="col md-12">
                    <div className="card rounded-0 cardTopBoxShadowremove">
                      <div
                        className="row justify-content-between"
                        style={{ padding: "0.6em 1.2rem" }}
                      >
                        <div className="d-flex col-12 col-lg-7 col-xl-7 p-0">
                          <div className="col-12 d-flex align-self-center">
                            <span className="fs-8">
                              {(this.state.totalRecords !== 0 || this.state.isDatanotfound) ? `These ${Utils.formatWithCommas(this.state.totalRecords)} numbers cannot receive texts. They have been removed from all groups/lists.` : ""}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-5 col-xl-5 ps-0">
                          <div
                            className="row justify-content-end"
                            style={{ width: "-webkit-fill-available" }}
                          >
                            <div
                              // className={
                              //   this.businessDomain ===
                              //     BUSINESS_DOMAIN.eventText
                              //     ? "col-sm-9 text-end p-0  align-self-end"
                              //     : "col-sm-7 text-end p-0  align-self-end"
                              // }
                              className="col text-end p-0  align-self-end"
                            >
                              <span className="me-2">
                                {this.state.isSelected && (
                                  <Button
                                    id="ptsHollowButton"
                                    variant="contained"
                                    type="submit"
                                    className="btn btn-default "
                                    startIcon={
                                      <i
                                        className="fa-regular fa-trash-can"
                                        aria-hidden="true"
                                        style={{
                                          borderRadius: "25%",
                                          color: "#23527c",
                                          fontSize: "16px",
                                          width: "30px",
                                          minHeight: "22px",
                                          padding: "3px",
                                          alignContent: "center",
                                          textAlign: "center",
                                          fontWeight: "600",
                                        }}
                                      ></i>
                                    } onClick={this.handleDeleteContactsOpen.bind(
                                      this
                                    )}
                                  >
                                    Delete contacts
                                  </Button>
                                )}
                              </span>
                              {this.state.invalidContactListArr?.length > 0 && (
                                <span className="me-3">
                                  {this.state.getReportPermission ? (
                                    <Button
                                      id="downloadReportButton"
                                      variant="contained"
                                      type="button"
                                      startIcon={
                                        <i
                                          className="fa fa-download"
                                          style={{ fontSize: "16px" }}
                                        ></i>
                                      }
                                      onClick={this.excelDownloadContacts.bind(
                                        this,
                                        "InvalidNumber"
                                      )}
                                    >
                                      Download Report
                                    </Button>
                                  ) : (
                                    <Button
                                      id="downloadReportButton"
                                      variant="contained"
                                      type="button"
                                      startIcon={
                                        <i
                                          className="fa fa-download"
                                          style={{ fontSize: "16px" }}
                                        ></i>
                                      }
                                      onClick={this.handleDownloadReportOpen.bind(
                                        this
                                      )}
                                    >
                                      Download Report
                                    </Button>
                                  )}
                                </span>
                              )}
                            </div>
                            <div
                              style={{
                                width:
                                  this.businessDomain !==
                                  BUSINESS_DOMAIN.eventText && "207.25px",
                              }}
                              // className={
                              //   this.businessDomain ===
                              //     BUSINESS_DOMAIN.eventText
                              //     ? "col-sm-3 text-end d-flex ps-0"
                              //     : "col-sm-5 text-end d-flex ps-0"
                              // }
                              className="col-sm-4 text-end d-flex ps-0 align-self-end"
                            >
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="text"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={this.onSearchChange.bind(this)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        onClick={this.getAllContactList.bind(
                                          this,
                                          this.state.selectedTab,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => {
                                          this.setState(
                                            { searchText: "" },
                                            () => {
                                              this.getAllContactList(
                                                this.state.selectedTab,
                                                this.state.pageNo,
                                                this.state.pageSize
                                              );
                                            }
                                          );
                                        }}
                                        disabled={!this.state.searchText}
                                      >
                                        <ClearIcon
                                          style={{
                                            opacity: this.state.searchText
                                              ? 1
                                              : 0.4,
                                            fontSize: "1.25rem",
                                            color: "353538",
                                          }}
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive paginationTable">
                        <table className="table text-start table-hover">
                          <thead className="paginationTableThead">
                            <tr>
                              <th scope="col fw-bold" style={{ width: "5%" }}>
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    marginTop: "6px",
                                  }}
                                  checked={this.state.allInvalidSelected}
                                  onChange={this.onAllInvalidCheckBoxSelect.bind(
                                    this
                                  )}
                                />
                              </th>
                              <th scope="col fw-bold" style={{ cursor: "pointer", width: "175px" }}
                                onClick={() => this.handleSort("mobile")}>Mobile Number
                                {this.state.sortColumn === "mobile" &&
                                  (this.state.sortDirection === "asc" ? (
                                    <i
                                      class="fa fa-long-arrow-up ps-1"
                                      aria-hidden="true"
                                    ></i>
                                  ) : (
                                    <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                  ))}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ cursor: "pointer", width: "140px" }}
                                onClick={() => this.handleSort("firstName")}
                              >
                                First Name
                                {this.renderSortIcon("firstName")}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ cursor: "pointer", width: "140px" }}
                                onClick={() => this.handleSort("lastName")}
                              >
                                Last Name
                                {this.renderSortIcon("lastName")}
                              </th>
                              <th scope="col fw-bold" style={{ cursor: "pointer", width: "160px" }}
                                onClick={() => this.handleSort("email")}>
                                Email
                                {this.renderSortIcon("email")}
                              </th>
                              <th scope="col fw-bold" style={{ cursor: "pointer", width: "180px" }}
                                onClick={() => this.handleSort("lastMessageSenton")}>
                                Failure Date
                                {this.renderSortIcon("lastMessageSenton")}
                              </th>
                              <th scope="col fw-bold" style={{ cursor: "pointer", width: "220px" }}
                                onClick={() => this.handleSort("invalidReason")}>
                                Failed Reason
                                {this.renderSortIcon("invalidReason")}
                              </th>
                              <th
                                scope="col fw-bold"
                                style={{ width: "120px", textAlign: "center" }}
                              >
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.invalidContactListArr?.map(
                              (rowData, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      rowData.id === this.state.contactId
                                        ? "#e6effc"
                                        : "",
                                  }}
                                >
                                  <td style={{ width: "50px" }}>
                                    <input
                                      type="checkbox"
                                      style={{
                                        width: "15px",
                                        height: "15px",
                                        marginTop: "6px",
                                      }}
                                      checked={
                                        rowData.checked ||
                                        this.state.allInvalidSelected
                                      }
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        this.onCheckBoxSelect(
                                          e,
                                          rowData,
                                          index
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{ width: "175px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {/* {this.state.getUpdatePermission ? (
                                      <span
                                        className="anchortag"
                                        onClick={(e) =>
                                          this.editContactDetails(e, rowData)
                                        }
                                      >
                                        {rowData.mobile}
                                      </span>
                                    ) : ( */}
                                    <span>{rowData.mobile}</span>
                                    {/* )} */}
                                  </td>
                                  <td
                                    style={{ width: "140px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.firstName}
                                  </td>
                                  <td
                                    style={{ width: "140px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.lastName}
                                  </td>
                                  <td
                                    style={{ width: "160px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.email}
                                  </td>
                                  <td
                                    style={{ width: "180px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.lastMessageSenton}
                                  </td>
                                  <td
                                    style={{ width: "220px" }}
                                    onClick={(e) =>
                                      this.handleRowClick(e, rowData, index)
                                    }
                                  >
                                    {rowData.invalidReason}
                                  </td>
                                  <td
                                    className="action-button"
                                    style={{
                                      width: "120px",
                                    }}
                                    key={rowData.id}
                                  >
                                    {this.showActionButton(rowData)}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                      {(this.state.totalRecords === 0) && (

                        <div
                          className="row text-center"
                          style={{ padding: "6px 20px" }}
                        >
                          <h5 className="dataNotAvailable">No data found.</h5>
                        </div>
                      )}
                      {this.state.totalRecords > 10 && (
                        <div className="row justify-content-between pagination p-1">
                          <div className="d-flex col-12 col-lg-5 col-xl-5">
                            <div className="pageSize col-12 text-start">
                              Page {this.state.pageNo + 1} of{" "}
                              {this.state.totalPages}
                            </div>
                          </div>
                          <div className="d-flex col-12 col-lg-2 col-xl-2">
                            <span className="pageSize me-4" style={{ fontSize: "14px" }}>
                              Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                            </span>
                          </div>
                          <div className="d-flex col-12 col-lg-5 col-xl-5">
                            <div className="col-12 text-end">
                              <Pagination
                                showPerPage={this.state.showPerPage}
                                onPaginationChange={this.onPaginationChange.bind(
                                  this
                                )}
                                total={this.state.totalRecords}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {this.state.invalidContactListArr.length > 10 &&
                <div className="row mt-3 mb-3">
                  <div className="col-sm-12 text-center">
                    {this.state.isSelected && (
                      <Button
                        id="ptsHollowButton"
                        variant="contained"
                        type="submit"
                        className="btn btn-default "
                        startIcon={
                          <i
                            className="fa-regular fa-trash-can"
                            aria-hidden="true"
                            style={{
                              borderRadius: "25%",
                              color: "#23527c",
                              fontSize: "16px",
                              width: "30px",
                              minHeight: "22px",
                              padding: "3px",
                              alignContent: "center",
                              textAlign: "center",
                              fontWeight: "600",
                            }}
                          ></i>
                        }
                        onClick={this.handleDeleteContactsOpen.bind(
                          this
                        )}
                      >
                        Delete contacts
                      </Button>
                    )}
                  </div>
                </div>
              }
            </TabPanel>
          </Tabs>
        </div >
        <Dialog
          open={this.state.openViewGroup}
          onClose={this.handleViewGroupClose.bind(this)}
          maxWidth="xl"
          className="groupBelongingToDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Groups Belonging To</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleViewGroupClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div
              md={12}
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
                padding: "0.5em",
              }}
            >
              <div className="row">
                <div className="col-md-12" style={{ paddingLeft: "24px" }}>
                  <div className="row">
                    <label
                      className="col-sm-1 col-form-label fw-bold"
                      htmlFor="basic-default-supplierType"
                      id="assetFormLabel"
                    >
                      Name
                    </label>
                    <div className="col-sm-11" id="givbeeText">
                      <span>{`${this.state.firstName !== null
                        ? this.state.firstName
                        : ""
                        } ${this.state.lastName !== null ? this.state.lastName : ""
                        }`}</span>
                    </div>
                  </div>
                  <div className="row">
                    <label
                      className="col-sm-1 col-form-label fw-bold"
                      htmlFor="basic-default-supplierType"
                      id="assetFormLabel"
                    >
                      Mobile
                    </label>
                    <div className="col-sm-11" id="givbeeText">
                      <span>
                        {Utils.phoneNumberFormate(this.state.mobileNo)}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <label
                      className="col-sm-1 col-form-label fw-bold"
                      htmlFor="basic-default-supplierType"
                      id="assetFormLabel"
                    >
                      Email
                    </label>
                    <div className="col-sm-11" id="givbeeText">
                      <span>{this.state.email}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 p-0 pb-2 groupForContact materialTable">
                <MaterialTable
                  title=""
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">No data found.</h5>
                      ),
                    },
                  }}
                  columns={[
                    // {
                    //   title: "#",
                    //   render: (rowData) => rowData.tableData.id + 1,
                    //   width: "5%",
                    //   align: "left",
                    //   cellStyle: {
                    //     width: "6%",
                    //   },
                    // },
                    {
                      title: "Group Name",
                      field: "name",
                    },
                    {
                      title: "Date added",
                      field: "createdOn",
                    },
                    {
                      title: "Action",
                      cellStyle: {
                        width: "20%",
                      },
                      sorting: false,
                      disableClick: true,
                      render: (rowData) => {
                        return (
                          <span className="me-2" style={{ cursor: "pointer" }}>
                            <RemoveContactButton
                              domainObject={Utils.phoneNumberFormate(
                                this.state.mobileNo
                              )}
                              onClick={this.deleteContactToGroup.bind(
                                this,
                                rowData
                              )}
                              pageId="Contact"
                            />
                          </span>
                        );
                      },
                    },
                  ]}
                  data={this.state.smsGroupList}
                  options={{
                    sorting: true,
                    search: false,
                    actionsColumnIndex: -1,
                    paging: false,
                    // headerStyle: {
                    //   backgroundColor: "#37517e",
                    //   fontWeight: "bold",
                    //   color: "#ffff",
                    //   align: "left",
                    // },
                  }}
                />
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.openEditContact}
          onClose={this.handleEditContactClose.bind(this)}
          maxWidth="xl"
          className="importContactDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Edit Contact</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleEditContactClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.updateContactToBackend.bind(this)}
          >
            <DialogContent className="pb-2">
              <div className="row ps-4 pe-4">
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-md-6" id="assetFormLabel">
                      <>
                        <label
                          className="form-label "
                          htmlFor="collapsible-firstname"
                        >
                          Mobile Number
                        </label>
                        <span
                          className="d-flex"
                          style={{ paddingLeft: "13px" }}
                        >
                          {this.state.mobileNo}
                        </span>
                      </>
                    </div>
                  </div>
                  <div className="row mt-1">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-firstname"
                      >
                        First Name
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.firstName}
                        onChange={this.handleFirstNameChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                  <div className="row mt-1">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        Last Name
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.lastName}
                        onChange={this.handleLastNameChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                  <div className="row mt-1">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        Email
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.email}
                        onChange={this.handleEmailChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row d-flex justify-content-center p-4">
                <div className="col-sm-6 text-center align-self-center">
                  <CreateButton btnName="Create" type="submit" />
                  &nbsp;&nbsp;
                  <CancelIconButton
                    btnName="Cancel"
                    onClick={(e) => this.handleEditContactClose()}
                  />
                </div>
              </div>
            </DialogContent>
          </ValidatorForm>
        </Dialog>
        <Dialog
          open={this.state.isDownloadReport}
          onClose={this.handleDownloadReportClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <span style={{ textAlign: "center" }}>
              <p className="mb-2" style={{ fontSize: "16px" }}>
                This feature is not enabled for your user type. Please contact
                admin.
              </p>
            </span>
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.isContactConfirmBoxOpen}
          onClose={this.handleDeleteContactsClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <span style={{ textAlign: "center" }}>
              <p className="m-0" style={{ fontSize: "16px" }}>
                Deleting contacts from the Opt-in List, will also delete them from ALL groups/lists.
              </p>
            </span>
          </DialogContent>
          <DialogActions
            style={{
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              type="button"
              size="large"
              style={{
                background: "#37517e",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<SaveIcon />}
              onClick={this.deleteMultipleContact.bind(this)}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              size="large"
              type="button"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<CloseIcon />}
              onClick={this.handleDeleteContactsClose.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withRouter(AllActiveContactList);
